// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"ProductListing_mainContent__sId32","primaryFacet":"ProductListing_primaryFacet__Ha_3g"};